if($('#single-list-box').length) {
    function single_list_callbacks() {
        $(".single_open").off('click').click(function (a) {
            var guid = $(this).data('guid');

            if ($('#single-det-' + guid).length > 0) {
                $('#single-det-' + guid).remove();
            } else {
                $('<tr id="single-det-' + guid + '"><td></td><td colspan="5"><div id="single-ajax-' + guid + '" style="text-align: center;"><img src="/templates/all/img/ajax_loader.gif" width="48" height="48" /></div></td></tr>')
                    .insertAfter('#single-' + guid);
                $.ajax({
                    type: "GET",
                    url: laroute.route('public::singles::ajax::open_single', {guid: guid})
                }).done(function (msg) {
                    //console.log(msg);
                    //if(window.fapPopupWin){
                    //    msg= msg.replace(/icon-headphones/g, "icon-plus-sign");
                    //    msg= msg.replace(/Podsłuch/g, "Dodaj do Playera");
                    //}
                    $('#single-ajax-' + guid).html(msg);
                    $('#single-ajax-' + guid).css('text-align', '');
                    $('.ptip_w').powerTip({
                        placement: 'w'
                    });
                    $('.ptip').powerTip({
                        placement: 'e'
                    });
                    $('.buy-now-track-btn').off('click').click(require('./../functions/track_buy_now_button.js'));
                    $('.add-to-cart-track-btn').off('click').click(require('./../functions/track_add_to_cart_button.js'));
                    $('.preview-btn').off('click').click(require('./../functions/preview_button.js'));
                    $('.preview-list-btn').off('click').click(require('./../functions/preview_list_button.js'));
                    $('.track-info-btn').off('click').click(require('./../functions/track_info_button.js'));
                    $('.propose-track-btn').off('click').click(require('./../functions/propose_track_button.js'));
                    $('.remove-propose-track-btn').off('click').click(require('./../functions/remove_propose_track_button.js'));
                    setTimeout(require('./../functions/replace_preview_button.js'), 500);
                });
            }

        });
    }
    single_list_callbacks();
}


$('.ptip_w').powerTip({
    placement: 'w'
});
$('.ptip').powerTip({
    placement: 'e'
});
$('.buy-now-track-btn').off('click').click(require('./../functions/track_buy_now_button.js'));
$('.add-to-cart-track-btn').off('click').click(require('./../functions/track_add_to_cart_button.js'));
$('.preview-btn').off('click').click(require('./../functions/preview_button.js'));
$('.preview-list-btn').off('click').click(require('./../functions/preview_list_button.js'));
$('.track-info-btn').off('click').click(require('./../functions/track_info_button.js'));
$('.propose-track-btn').off('click').click(require('./../functions/propose_track_button.js'));
$('.remove-propose-track-btn').off('click').click(require('./../functions/remove_propose_track_button.js'));
setTimeout(require('./../functions/replace_preview_button.js'), 500);


//function odsluch(url, tytul, wykonawca, okladka, id, price)
//{
//    //<?=$l['id']?>, '<?=$l['wykonawca']?> - <?=$l['tytul']?> (<?=$l['wersja']?>)', '<?=number_format($_PRICES[$_SESSION['user']['grupacenowa']][$price['tier']], 0)?>')
//    //$.fullwidthAudioPlayer.clear();
//    link = '';
//    if(id != ''){
//        link = "javascript:do_koszyka("+id+", '"+wykonawca+" - "+tytul+"', '"+price+"')";
//    }
//    if(!window.fapPopupWin){
//        $.fullwidthAudioPlayer.clear();
//    }
//    $.fullwidthAudioPlayer.addTrack(url, tytul, wykonawca, okladka, link, !window.fapPopupWin);
//    if(!window.fapPopupWin){
//        $.fullwidthAudioPlayer.play();
//        $.fullwidthAudioPlayer.setPlayerPosition('open', true);
//        $.fullwidthAudioPlayer.setPlayerPosition('closePlaylist', true);
//    }
//}

//function kup_all(id)
//{
//    $.ajax({
//        type: "GET",
//        url: "?buyall=1",
//        data: { id: id }
//    }).done(function( msg ) {
//        if(msg == -1)
//        {
//            $.sticky('<?=addslashes(__('Posiadasz już wszystkie utwory zawarte w tym singlu.', 'SINGLES'))?>', {autoclose : 3000, position: 'top-right', type: 'st-info' });
//        }else{
//            //console.log(msg);
//            var obj = jQuery.parseJSON(msg);
//            //console.log(obj);
//            var text = "<b></b>Czy chcesz zakupić poniższe utwory za <span class='badge'>"+obj.sum+" <?=ConfigGet('PTZ')?></span>?:<ul>";
//            for (index = 0; index < obj.ToBuy.length; ++index) {
//                text = text + "<li>"+obj.ToBuy[index].wykonawca+" - "+obj.ToBuy[index].tytul+" ("+obj.ToBuy[index].wersja+")</li>";
//            }
//            text = text + "</ul>"+obj.text
//            bootbox.confirm(text, function(confirmed) {
//                if(confirmed){
//                    if(obj.can == false)
//                    {
//                        $.sticky('<b>'+obj.BundleTitle+'</b><br /><?=addslashes(__('Nie masz wystarczającej liczby PTZ na koncie.', 'SINGLES'))?>', {autoclose : 3000, position: 'top-right', type: 'st-error' });
//                    }else{
//                        $.ajax({
//                            type: "GET",
//                            url: "?buyall=1&confirm=1",
//                            data: { id: id }
//                        }).done(function( msg ) {
//                            if(msg == -1)
//                            {
//                                $.sticky('<b>'+obj.BundleTitle+'</b><br /><?=addslashes(__('Nie masz wystarczającej liczby PTZ na koncie.', 'SINGLES'))?>', {autoclose : 3000, position: 'top-right', type: 'st-error' });
//                            }else{
//                                console.log(msg);
//                                var obj = jQuery.parseJSON(msg);
//                                console.log(obj);
//                                bootbox.dialog("Utwory zostały pomyślnie zakupione. Czy chcesz je pobrać teraz?",
//                                    [
//                                        {
//                                            "label" : "Nie",
//                                            "class" : "btn-danger",
//                                            "callback": function() {
//
//                                            }
//                                        },
//                                        {
//                                            "label" : "Tak",
//                                            "class" : "btn-success",
//                                            "callback": function() {
//                                                post("/konto/pobierz", obj.postString);
//                                            }
//                                        }
//                                    ]);
//                            }
//                        });
//                    }
//                }
//            });
//        }
//    });
//}



//function post(path, parameters) {
//    var form = $('<form></form>');
//
//    form.attr("method", "post");
//    form.attr("action", path);
//
//    $.each(parameters, function(key, value) {
//        var field = $('<input></input>');
//
//        field.attr("type", "hidden");
//        field.attr("name", key);
//        field.attr("value", value);
//
//        form.append(field);
//    });
//
//    // The form needs to be a part of the document in
//    // order for us to be able to submit it.
//    $(document.body).append(form);
//    form.submit();
//}






//function ptzadd(ptz, add, mnx, num)
//{
//    if(typeof(mnx)==='undefined') mnx = 1;
//    if(num==true)
//    {
//        return Number(str_replace(',', '', str_replace(' <?=ConfigGet('PTZ')?>', '', ptz)))+mnx*Number(str_replace(',', '', add));
//    }else{
//        return number_format(Number(str_replace(',', '', str_replace(' <?=ConfigGet('PTZ')?>', '', ptz)))+mnx*Number(str_replace(',', '', add)));
//    }
//}
//
//function do_koszyka(id, nazwa, cena)
//{
//    $.ajax({
//        type: "GET",
//        url: "?puttocart=1",
//        data: { id: id }
//    }).done(function( msg ) {
//        if(msg==1)
//        {
//            $.sticky('<b>'+nazwa+'</b><br /><?=__('Utwór został dodany do koszyka.', 'SINGLES')?>', {autoclose : 3000, position: 'top-right', type: 'st-success' });
//            $('#dokoszyka'+id).addClass('disabled').attr('href', 'javascript:void(0)');
//            $('#ilewkoszyku').html(Number($('#ilewkoszyku').html())+1);
//            $('#sumawkoszyku').html(ptzadd($('#sumawkoszyku').html(), cena));
//        }else{
//            $.sticky('<b>'+nazwa+'</b><br /><?=__('Utwór już istnieje w koszyku.', 'SINGLES')?>', {autoclose : 3000, position: 'top-right', type: 'st-info' });
//        }
//    });
//}
